import { animate, state, style, transition, trigger } from '@angular/animations';

export const SwitchAnimation = trigger('switch', [
  state('false', style({ transform: 'scaleY(1)' })),
  state('true', style({ transform: 'scaleY(-1)' })),
  transition('true => false', animate('100ms')),
  transition('false => true', animate('100ms')),
]);
